import { isAiUser } from '../config/aiUsers';

/**
 * Why the Manage button has to refuse a call, as an i18n key, or '' when the
 * operator may take it. A call nobody holds is open to whoever finds it, a
 * held one only to its holder. updateCallSaga enforces the same on write, so
 * the button refuses first and says who has the call.
 */
export const callLockReason = (call, userId) => {
  const holder = call.userId;
  if (!holder || holder === userId) return '';
  return isAiUser(holder)
    ? 'Call handled by the AI agent'
    : 'Call assigned to another operator';
};
